module.exports = __webpack_public_path__ + "static/media/rajkamal.6efc0316.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/rajkamal.jpg
// module id = 1281
// module chunks = 0